// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1mJh6","name":"Header_name__3wZjr","birthday":"Header_birthday__1XvM_","skeleton":"Header_skeleton__3KWeF"};